
const AUX = props => props.children;

export default AUX;